import { useEffect, useRef } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
type VideoPlayerType = {
  resourceLink: string;
};
const VideoPlayer = ({ resourceLink }: VideoPlayerType) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const playerRef = useRef<any>(null);
  useEffect(() => {
  if (videoRef.current) {
    playerRef.current = videojs(videoRef.current, {
      controls: true,
      autoplay: false,
      preload: "auto",
      fluid: true,
      controlBar: { fullscreenToggle: true },
    });

    const watermark = document.createElement("img");
    watermark.src = "/logo.png";
    watermark.style.position = "absolute";
    watermark.style.top = "12px";
    watermark.style.right = "12px";
    watermark.style.width = "60px"; 
    watermark.style.opacity = "0.55";
    watermark.style.pointerEvents = "none";
    watermark.style.zIndex = "9999";

    const playerContainer = playerRef.current.el();
    playerContainer.appendChild(watermark);

    const handleFullscreenChange = () => {
      if (document.fullscreenElement) {
        watermark.style.width = "120px"; 
      } else {
        watermark.style.width = "60px"; 
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);

      if (playerRef.current) {
        playerRef.current.dispose();
      }
    };
  }
}, [resourceLink]);

  return (
    <div>
      <video
        ref={videoRef}
        className="video-js vjs-big-play-centered"
        playsInline
      >
        <source src={resourceLink} type="video/mp4" />
      </video>
    </div>
  );
};

export default VideoPlayer;


